import React from 'react'

/**
 * Gemensam stil för Målindex modaler.
 *
 * Ant Designs standardknappar är 32px höga med 14px text. Det är för smått här:
 * resten av flödet håller 44–46px och 16px för att fungera med ett finger på en
 * platta, och modalernas fotknappar är dessutom de mest konsekvensrika i hela
 * funktionen – de startar, sparar och kastar besök.
 *
 * Ligger i en egen modul just för att de fyra modalerna annars glider isär igen.
 */

/** Fotknapparnas storlek. Samma tap-mål som stegknapparna i flödena. */
export const MODAL_KNAPP = { style: { height: 44, fontSize: 16, paddingInline: 20 } }

/**
 * Den oåterkalleliga knappen: grå ram, röd text, ingen fyllning.
 *
 * Ant Designs `danger` färgar både text och ram, och intill en fylld primärknapp blir
 * det två färgade block som konkurrerar. Rött ska MÄRKA att handlingen inte går att
 * ångra, inte dra ögat till den – den enda vägen som inte går att backa ur ska aldrig
 * vara den tyngsta på skärmen.
 *
 * Ramen behålls. På en platta är kanten det som visar var man kan trycka, och en
 * borderlös knapp läses som en länk.
 *
 * Fylld röd hör bara hemma i en dialog vars hela syfte ÄR att radera något. Här är
 * syftet att besöket inte är klart, och att kasta det är ett av tre svar.
 */
export const MODAL_KNAPP_FARLIG = {
  style: { ...MODAL_KNAPP.style, color: '#cf1322' },
}

/**
 * Samma bredd på ALLA modaler.
 *
 * 520 var för trångt: modalerna bär flera stycken text och en varningsruta, och raderna
 * blev korta och tätt staplade. 640 räcker också till ÄrendeID-modalens hjälptext, som
 * tidigare hade en egen bredd – nu finns bara ett mått i hela funktionen.
 */
export const MODAL_BREDD = 640

/**
 * Modalerna i besöksflödet är grindar, inte fönster: något MÅSTE väljas för att
 * komma vidare, och knapparna är de enda vägarna ut. Därför stängs krysset,
 * Esc-tangenten och klick utanför av på allihop.
 *
 * Krysset var inte bara överflödigt utan farligt. Ant Design kopplar det till
 * `onCancel` – samma handling som den vänstra knappen. I "Har behoven förändrats?"
 * betydde alltså ett tryck på krysset "Nej, avsluta besök och spara": rutan såg ut
 * att bara stängas, men besöket avslutades. Esc gjorde detsamma.
 */
export const MODAL_GRIND = { closable: false, maskClosable: false, keyboard: false }

/**
 * Modalrubrik i appens vikt och storlek. Ant sätter 16px/500 som är mindre
 * markerat än brödtexten under.
 */
export const modalTitel = (text: string): React.ReactNode =>
  React.createElement('span', { style: { fontSize: 18, fontWeight: 600 } }, text)
